import React from 'react';

const MessageBubble = ({ sender, text, time, modelAI }) => {
  const isMe = sender === 'user';

  const formattedDateTime = new Date(time).toLocaleString("th-TH", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });

  return (
    <div className={`d-flex ${isMe ? 'justify-content-end' : 'justify-content-start'} mb-2`}>
      <div
        className={`p-3 rounded-3 ${isMe ? 'bg-primary text-white' : 'bg-light text-dark'}`}
        style={{ maxWidth: '60%' }}
      >
        <div style={{ whiteSpace: 'pre-wrap' }}>{text}</div>
        <div className="small text-end mt-1">{formattedDateTime}</div>
        {modelAI && (
            <div className="text-muted text-end" style={{ fontSize: '0.75rem' }}>
              {`Model: ${modelAI}`}
            </div>
          )}
      </div>
    </div>
  );
};

export default MessageBubble;
